import React from "react"
import { useTranslation } from "react-i18next"

const Switch2 = ({ isChecked, isReadOnly, id }) => {
  const { t } = useTranslation()

  return (
    <div className="square-switch">
      <input
        type="checkbox"
        id={id}
        className="switch"
        checked={isChecked}
        readOnly={isReadOnly}
      />
      <label
        htmlFor={id}
        data-on-label={t("On")}
        data-off-label={t("Off")}
        style={{
          cursor: isReadOnly ? "unset" : "pointer",
        }}
      />
    </div>
  )
}

export default Switch2
